/* eslint-disable import/prefer-default-export */
import { Duration } from 'luxon'

export function formatDistance( start, end ) {
  return formatDuration( end - start )
}

export function formatDuration( duration, opts = { daysToHours : false } ) {
  return Duration
    .fromMillis( duration )
    .rescale()
    .set( { milliseconds : 0 } )
    .rescale()
    .toHuman( { unitDisplay : 'short', listStyle : 'narrow' } )
}

export function buildImageUrl( bucketUrl, imageName ) {
  
  const path = imageName.endsWith( '.jpg' ) ? imageName : `${imageName}.jpg`

  const url = `${bucketUrl}/${path}`

  return encodeURI( url )
}
